const getApplication = state => state.application;
const getApplicationsList = state => state.applications;
const getcurrentApplicant = state => state.currentApplicant;
const getFutureGuarantor = state => state.future_guarantor;
const getFutureApplicant = state => state.future_applicant;
const applicationToLease = state => state.application_to_lease;

export default {
    getApplication,
    getcurrentApplicant,
    getApplicationsList,
    getFutureGuarantor,
    getFutureApplicant,
    applicationToLease,
};
